import { LineString, Point } from "ol/geom";
import { Icon, Stroke, Style } from "ol/style";
import { colorForSpeed } from "./util/colorScale";
import { maxSpeedFromCurvature } from "./curvature";
import { applyOverlapOffset } from "./util/arcOverlapOffset";
import { sampleAlong } from "./util/polyline.mjs";

const ARROW_FRACTIONS = [1 / 3, 2 / 3];
const ARROW_SCALE = 0.5;

// Two travel-direction arrowheads along `coords` (already offset), tinted `color`.
// icon-arrow.png points right by default, so rotation = -heading aligns it.
function getArrowStyles(coords, color) {
  return ARROW_FRACTIONS.map((f) => {
    const { point, rotation } = sampleAlong(coords, f);
    return new Style({
      geometry: new Point(point),
      image: new Icon({
        src: "icon-arrow.png",
        anchor: [0.5, 0.5],
        rotateWithView: true,
        rotation: -rotation,
        color: color,
        scale: [ARROW_SCALE, ARROW_SCALE],
      }),
    });
  });
}

export function getCaJStyleNormalOrbisSD(feature, resolution) {
  return getCaJColorStyle(feature, false, false, resolution);
}
export function getCaJStyleClickOrbisSD(feature, resolution) {
  return getCaJColorStyle(feature, true, false, resolution);
}
export function getCaJStyleHoverOrbisSD(feature, resolution) {
  return getCaJColorStyle(feature, false, true, resolution);
}

function getCaJColorStyle(feature, click, hover, resolution) {
  let width, backgroundWidth;
  const type = feature.get("type");

  if (type !== "curvature-arc" && type !== "curvature-arc-dummy") {
    return new Style({});
  }

  const curvature = Number(feature.get("curvature_at_junction"));
  const speed = isNaN(curvature) ? 0 : maxSpeedFromCurvature(curvature);
  const [r, g, b] = colorForSpeed(speed);
  const color = `rgb(${r},${g},${b})`;

  if (hover || click) {
    width = 7;
    backgroundWidth = 10;
  } else {
    width = 5;
    backgroundWidth = 9;
  }

  const coords = applyOverlapOffset(
    feature.getGeometry().getCoordinates(),
    feature,
    resolution,
  );
  const geometry = new LineString(coords);

  return [
    new Style({
      geometry,
      stroke: new Stroke({ color: "white", width: backgroundWidth }),
    }),
    new Style({
      geometry,
      stroke: new Stroke({ color: color, width: width }),
    }),
    ...getArrowStyles(coords, color),
  ];
}
